//---------------- IMPORTAÇÕES ----------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";

//---------------- FUNÇÃO PARA BUSCAR LEADS ORGANIZADAS POR TRANSAÇÃO ----------------//
export default async function loadLeadsService(limit, offset, term, filterStatus, filterTag, filterIntegration) {
  try {
    const response = await api.post("/vendas/leads-estruturadas", {
      limit,
      offset,
      busca: term || null,
      status: filterStatus || null,
      tag: filterTag || null,
      integracoes: filterIntegration || null,
    });
    return response;
  } catch (error) {
    toast.error("Erro ao carregar leads");
    return null;
  }
}